// 3rd party
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'my-dt-pagination',
  templateUrl: './my-dt-pagination.component.html',
  styleUrls: ['./my-dt-pagination.component.css']
})
export class MyDTPaginationComponent {

  @Input() currentPage: number;
  @Input() pageSize: number;
  @Input() totalItems: number;
  @Input() totalPages: number;

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() next: EventEmitter<any> = new EventEmitter();
  @Output() previous: EventEmitter<any> = new EventEmitter();

  size: number = 25;

  changeSize(size: number) {
    if (size === this.size) {
      return;
    }

    if (!(this.totalItems <= this.size && this.size <= size)) {
      this.size = size;
      this.change.emit(this.size);
    }
    this.size = size;
  }

  getEndRow() {
    let endRow = this.currentPage * this.pageSize;
    return endRow >= this.totalItems ? this.totalItems : endRow;
  }

  getStartRow() {
    if (this.totalItems === 0) {
      return 0;
    }
    return this.currentPage * this.pageSize - this.pageSize + 1;
  }

  nextPage() {
    this.currentPage++;
    this.next.emit(this.currentPage);
  }

  previousPage() {
    if (this.currentPage <= 1) {
      return;
    }
    this.currentPage--;
    this.previous.emit(this.currentPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt-pagination/my-dt-pagination.component.ts